// If enabled, log any warnings generated by jquery-migrate for the purpose of identifying and fixing issues

var SCM = SCM || {};
SCM.JqueryMigrateLogger = function() {
    var pollTimeInMs = 5000;
    var pollLimit = 20;
    var pollCount = 0;
    var $loggingDetailElement;
    var logger;

    return {
        init: _init
    };

    function _init() {
        logger = SCM.Logging.getLogger();
        if (!_isLoggingEnabled()) {
            logger.debug('jquery-migrate logging is disabled');
            return;
        }

        var instrumentationKey = _getInstrumentationKey();
        if (instrumentationKey) {
            logger.debug('jquery-migrate logging mode: Application Insights.');
            _initApplicationInsights(instrumentationKey);
            if (!window.appInsights) {
                logger.warn('Application Insights failed to initialize.');
                return;
            }
        } else {
            logger.debug('jquery-migrate logging mode: console only.');
            if (window.jQuery) {
                jQuery.migrateMute = false;
                jQuery.migrateTrace = true;
            }
        }
        setTimeout(_logWarnings, pollTimeInMs);
    }

    function _getInstrumentationKey() {
        if (!$loggingDetailElement || !$loggingDetailElement.length) {
            return '';
        }
        var key = $loggingDetailElement.data('jqueryMigrateInstrumentationKey');
        return key ? key.trim() : '';
    }

    function _initApplicationInsights(instrumentationKey) {
        var sdkInstance="appInsightsSDK";window[sdkInstance]="appInsights";var aiName=window[sdkInstance],aisdk=window[aiName]||function(e){function n(e){t[e]=function(){var n=arguments;t.queue.push(function(){t[e].apply(t,n)})}}var t={config:e};t.initialize=!0;var i=document,a=window;setTimeout(function(){var n=i.createElement("script");n.src=e.url||"https://az416426.vo.msecnd.net/scripts/b/ai.2.min.js",i.getElementsByTagName("script")[0].parentNode.appendChild(n)});try{t.cookie=i.cookie}catch(e){}t.queue=[],t.version=2;for(var r=["Event","PageView","Exception","Trace","DependencyData","Metric","PageViewPerformance"];r.length;)n("track"+r.pop());n("startTrackPage"),n("stopTrackPage");var s="Track"+r[0];if(n("start"+s),n("stop"+s),n("setAuthenticatedUserContext"),n("clearAuthenticatedUserContext"),n("flush"),!(!0===e.disableExceptionTracking||e.extensionConfig&&e.extensionConfig.ApplicationInsightsAnalytics&&!0===e.extensionConfig.ApplicationInsightsAnalytics.disableExceptionTracking)){n("_"+(r="onerror"));var o=a[r];a[r]=function(e,n,i,a,s){var c=o&&o(e,n,i,a,s);return!0!==c&&t["_"+r]({message:e,url:n,lineNumber:i,columnNumber:a,error:s}),c},e.autoExceptionInstrumented=!0}return t}(
            {
                instrumentationKey: instrumentationKey,
                disableAjaxTracking: true
            }
        );
        window[aiName] = aisdk;  // [We don't want to track page views.]  aisdk.queue && 0 === aisdk.queue.length&&aisdk.trackPageView({});
    }

    function _isLoggingEnabled() {
        $loggingDetailElement = $('[data-jquery-migrate-logging-enabled]');
        return $loggingDetailElement && $loggingDetailElement.length && jQuery.migrateWarnings;
    }

    function _logWarnings() {
        if (jQuery.migrateWarnings && jQuery.migrateWarnings.length) {
            logger.debug('Logging ' + jQuery.migrateWarnings.length + ' jquery-migrate warnings.');
            jQuery.migrateWarnings.forEach(function (w) {
                logger.debug(w);
                if (window.appInsights) {
                    appInsights.trackEvent({
                        name: 'jquery-migrate-warning',
                        properties: {
                            host: window.location.hostname,
                            url: window.location.href,
                            warning: w
                        }
                    });
                } else {
                    console.warn('[JQMIGRATE] ' + w);
                }
            });
            jQuery.migrateReset();
        }
        pollCount++;
        if (pollCount < pollLimit) {
            setTimeout(_logWarnings, pollTimeInMs);
        }
    }

}();
